export const CONTROLLERS = {
  AZURE_BLOB: 'AzureBlob',
  MEMBERS: 'Members',
  PRACTICE: 'Practice',
  PICK_LIST: 'PickList',
  DATA_CONTEXT: 'DataContext',
  PRACTICE_CONFIG: 'PracticeConfig',
  ONBOARDING_STATUS: 'OnboardingStatus',
  CMS: 'CMS',
  SCHEDULE_JOB: 'ScheduleJob',
  USER_X_PRACTICE: 'UserXPractice',
  CUSTOMER: 'Customer',
  PAYMENTMETHODMASTER: 'PaymentMethodMaster',
  ROLEMASTER: 'RoleMaster',
  CARRIERMASTER: 'CarrierMaster',
  CARRIERPLAN: 'CarrierPlan',
  SUBSCRIPTION: 'Subscription',
  MODULE: 'Module',
  SHARED_FORM: 'SharedForm',
  INSTALLER_VERSION: 'InstallerVersion',
  // Task 3510: the customer app tells the Controller API a user landed on a tracked page.
  PAGE_VISIT: 'PageVisit',
  PAY_NOW: 'PayNow',
  // Task/3424 (Refund Authenticator): these four hit ToothTeller-Controller-API directly (no
  // TENANTS/PAYMENTS prefix, so ApiService.getApiUri falls through to its default
  // environment.apiUrl branch) - the config side of the feature (templates, reason codes,
  // approval matrix, signature/branding settings).
  REFUND_SETTLEMENT_TEMPLATE: 'RefundSettlementTemplate',
  REFUND_REASON_CODE: 'RefundReasonCode',
  REFUND_APPROVAL_RULE: 'RefundApprovalRule',
  REFUND_SIGNATURE_SETTINGS: 'RefundSignatureSettings',
  TENANTS: {
    AR_DASHBOARD:'ARDashboard',
    PAYMENT_DASHBOARD: 'PaymentDashboard',
    PAYMENT_PIAN_DASHBOARD: 'PaymentPlanDashboard',
    PATIENT: 'Patient',
    PRACTICE: 'TenantPractice',
    GRAPHS: 'Graphs',
    BILLING_ADDRESS: 'BillingAddress',
    PROVIDER: 'Provider',
    AR_AUTOMATION: 'ARAutomation',
    INSURANCE_COMPANY: 'InsuranceCompany',
    CAMPAIGN: 'Campaign',
    CAMPAIGN_TEMPLATE: 'CampaignTemplate',
    COMMUNICATION_TEMPLATE: 'CommunicationTemplate',
    CUSTOM_FILTER: 'CustomFilter',
    SMS_TEMPLATE: 'SMSTemplate',
    EMAIL_TEMPLATE: 'EmailTemplate',
    PAYTYPE: 'PayType',
    PAYMENT_METHOD_MAPPING: 'PaymentMethod',
    PRACTICE_ASSESSMENT: 'Assesment',
    CUSTOM_FORM: 'CustomForm',
    HOST_PAYMENT_PAGE: 'HostPaymentPage',
    PRACTICE_CONFIGURATION: 'PracticeConfiguration',
    MEMBER_MODULE_REPORT: 'MemberModuleReport',
    PAYMENTREPORT: 'PaymentReports',
    CARRIERMAPPING: 'CarrierMapping',
    AR_REPORT: 'ARReport',
  },
  PAYMENTS: {
    TERMINAL: 'Terminal',
    MERCHANT_ACCOUNT: 'MerchantAccount',
    TOKEN: 'Token',
    PAYMENT: 'Payment',
    PAYMENT_PLAN: 'PaymentPlan',
    PRE_PAYMENT: 'PrePayment',
    PROCESSOR: 'Processor',
    INVOICE: 'Invoice',
    BILLING_ADDRESSES:'BillingAddresses',
    REFUND_SETTLEMENT: 'RefundSettlement', // Task/3424 (Refund Authenticator)
    REFUND_MESSAGE_TEMPLATE: 'RefundMessageTemplate', // Task/3424 - refund email / text wording
  },
  TTINFOSETTING : 'TTInfoSetting',
  PRACTICEAGREEMENTHISTORY : 'PracticeAgreementHistory',
  POLICYDOCUMENTS : 'PolicyDocuments',
  SHARED_AGREEMENT_FORM: 'SharedAgreementForm',
  CREDIT : 'Credit',
  PRICINGPLAN:'PricingPlan',
  SECURITY_QUESTIONS: 'SecurityQuestions',
  SECURITY: 'Security',
};
